// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://cra.link/PWA

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    //console.log("1");
    // The URL constructor is available in all browsers that support SW.
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
        //console.log("2");
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
      return;
    }

    window.addEventListener('load', () => {
        //console.log("3");
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        // This is running on localhost. Let's check if a service worker still exists or not.
        checkValidServiceWorker(swUrl, config);

        // Add some additional logging to localhost, pointing developers to the
        // service worker/PWA documentation.
        navigator.serviceWorker.ready.then(() => {
          /* console.log(
            'This web app is being served cache-first by a service ' +
              'worker. To learn more, visit https://cra.link/PWA'
          ); */
        });
      } else {
        //console.log("7");
        // Is not localhost. Just register service worker
        registerValidSW(swUrl, config);
      }
    });
  } else {
    if (config && config.onCancel) {
        config.onCancel();
    }
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        //console.log("4");
        const installingWorker = registration.installing;
        if (installingWorker == null) {
            //console.log("5");
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            //console.log("6");
            if (navigator.serviceWorker.controller) {
              // At this point, the updated precached content has been fetched,
              // but the previous service worker will still serve the older
              // content until all client tabs are closed.
              /* console.log(
                'New content is available. Reloading page...'
              ); */

              // Execute callback
              if (config && config.onUpdate) {
                config.onUpdate(registration, { atStartup: false });
              }
            } else {
              // At this point, everything has been precached.
              // It's the perfect time to display a
              // "Content is cached for offline use." message.
              //console.log('Content is cached for offline use.');

              // Execute callback
              if (config && config.onSuccess) {
                config.onSuccess();
              }
            }
          }
        };
      };
      // Un aggiornamento gia' scaricato in una visita precedente e rimasto in attesa:
      // all'avvio della pagina non scatta onupdatefound, quindi lo segnaliamo qui.
      if (registration.waiting && navigator.serviceWorker.controller) {
        if (config && config.onUpdate) {
          config.onUpdate(registration, { atStartup: true });
        }
      }
      // Check if there are no updates
      if (!registration.waiting && !registration.installing) {
        //console.log("No updates found.");
        //console.warn("IF THE PAGE IS STUCK LOADING, PLEASE CLOSE THE CONSOLE AND RELOAD THE PAGE A FEW TIMES");
        //console.warn("SE LA PAGINA È BLOCCATA NEL CARICAMENTO, CHIUDI LA CONSOLE E RICARICALA UN PO' DI VOLTE");
        if (config && config.onCancel) {
          config.onCancel();
        }
      }
    })
    .catch((error) => {
      //console.error('Error during service worker registration:', error);
      if (config && config.onCancel) {
        config.onCancel();
      }
    });
}

function checkValidServiceWorker(swUrl, config) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      // Ensure service worker exists, and that we really are getting a JS file.
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker found. Proceed as normal.
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      //console.log('No internet connection found. App is running in offline mode.');
    });
}

// Registration con un aggiornamento in attesa (impostata da onUpdate in index.js)
let pendingRegistration = null;
// Evita di registrare piu' di un listener controllerchange / ricaricare piu' volte
let applyingUpdate = false;

export function setPendingUpdate(registration) {
  pendingRegistration = registration;
}

// Attiva il service worker in attesa e ricarica la pagina quando prende il controllo.
// Restituisce true se l'applicazione e' stata avviata, false se non c'e' nulla da applicare.
export function applyPendingUpdate() {
  if (applyingUpdate) {
    return true;
  }
  if (!pendingRegistration || !pendingRegistration.waiting) {
    return false;
  }
  applyingUpdate = true;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    window.location.reload();
  });
  pendingRegistration.waiting.postMessage({ type: 'SKIP_WAITING' });
  return true;
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
